import React from 'react';
import { motion } from 'framer-motion';
import { ImageIcon } from 'lucide-react';
const products = [{
  title: 'Pop Top Roof Supply & Installation',
  vehicle: 'Kia PV5 Cargo – L1/H1',
  price: 'From £3,217 +VAT',
  image: ''
}, {
  title: 'Swivel Seats with Centre Console',
  vehicle: 'Kia PV5 Cargo – L1/H1',
  price: 'From £612 +VAT',
  image: ''
}, {
  title: 'Rear Bed System',
  vehicle: 'Kia PV5 Passenger',
  price: '£TBC',
  image: ''
}, {
  title: 'U-Bed System',
  vehicle: 'Kia PV5 Cargo',
  price: 'From £2,995 +VAT',
  image: ''
}, {
  title: 'RIB Seat',
  vehicle: 'Kia PV5 Cargo',
  price: 'From £1,250 +VAT',
  image: ''
}];
export function ProductsSection() {
  return <section id="products" className="relative w-full bg-dark-800 py-24 md:py-32" data-id="element-137">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-138">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="text-center mb-16" data-id="element-139">
          <p className="text-gold text-sm font-semibold tracking-[0.3em] uppercase mb-4 font-body" data-id="element-140">
            Products & Pricing
          </p>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold" data-id="element-141">
            Conversion <span className="text-gold italic" data-id="element-142">Options</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-143">
          {products.map((product, i) => <motion.div key={product.title} initial={{
          opacity: 0,
          y: 25
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`group relative bg-dark-900/60 border border-white/5 rounded-xl overflow-hidden hover:border-gold/30 transition-all duration-500 ${i >= 3 ? 'lg:col-span-1 sm:col-span-1' : ''}`} data-id="element-144">
              {/* Image area */}
              <div className="aspect-[16/10] overflow-hidden bg-dark-700/50" data-id="element-145">
                {product.image ? <img src={product.image} alt={product.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-146" /> : <div className="w-full h-full flex flex-col items-center justify-center text-white/15" data-id="element-147">
                    <ImageIcon size={40} strokeWidth={1} data-id="element-148" />
                    <span className="text-xs mt-2 font-body" data-id="element-149">
                      Image coming soon
                    </span>
                  </div>}
              </div>

              {/* Content */}
              <div className="p-6" data-id="element-150">
                <p className="text-gold/60 text-xs font-semibold tracking-[0.2em] uppercase mb-2 font-body" data-id="element-151">
                  {product.vehicle}
                </p>
                <h3 className="font-display text-lg font-semibold mb-4 leading-snug" data-id="element-152">
                  {product.title}
                </h3>
                <div className="flex items-baseline gap-2" data-id="element-153">
                  <span className="text-gold font-display text-xl font-bold" data-id="element-154">
                    {product.price}
                  </span>
                </div>
              </div>

              <div className="absolute bottom-0 left-6 right-6 h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-155" />
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        delay: 0.5
      }} className="text-center text-white/30 text-sm font-body mt-10" data-id="element-156">
          All prices exclude VAT unless stated. Contact us for a full bespoke
          quotation.
        </motion.p>
      </div>
    </section>;
}